import { render, staticRenderFns } from "./AiModuleScreen.vue?vue&type=template&id=326bfcb8&scoped=true&"
import script from "./AiModuleScreen.vue?vue&type=script&lang=ts&"
export * from "./AiModuleScreen.vue?vue&type=script&lang=ts&"
import style0 from "./AiModuleScreen.vue?vue&type=style&index=0&id=326bfcb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326bfcb8",
  null
  
)

export default component.exports